import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [isComplianceOpen, setIsComplianceOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    if (window.location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <img 
              src="https://static.readdy.ai/image/f0817863ebc92fa27256ed37b93c2254/fbfbf934f6ae749d0607a80c76938440.png" 
              alt="Congarantías SAS" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm">
              Más de una década contribuyendo al bienestar financiero de nuestros clientes.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
              <i className="ri-links-line text-amber-400"></i>
              Enlaces Rápidos
            </h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer text-left"
                >
                  Inicio
                </button>
              </li>
              <li>
                <Link
                  to="/pagar-deuda"
                  className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer"
                >
                  Pagar Deuda
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer text-left"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
              <i className="ri-phone-line text-amber-400"></i>
              Contacto
            </h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li className="flex items-center gap-2 hover:text-amber-400 transition-colors">
                <i className="ri-phone-fill text-gray-500"></i>
                (601) 7942180
              </li>
              <li className="flex items-center gap-2 hover:text-amber-400 transition-colors">
                <i className="ri-whatsapp-fill text-gray-500"></i>
                +57 318 336 5407
              </li>
              <li className="flex items-center gap-2 hover:text-amber-400 transition-colors">
                <i className="ri-mail-fill text-gray-500"></i>
                Cobranzas@cash24-7.co
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
              <i className="ri-time-line text-amber-400"></i>
              Horarios
            </h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-calendar-line text-gray-500 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-medium text-white">Lunes a Viernes</p>
                  <p>8:00 a.m. - 6:00 p.m.</p>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-calendar-line text-gray-500 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-medium text-white">Sábados</p>
                  <p>8:00 a.m. - 3:00 p.m.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 mb-6">
          <div className="max-w-4xl mx-auto">
            <button
              onClick={() => setIsComplianceOpen(!isComplianceOpen)}
              className="w-full flex items-center justify-between bg-gray-900 hover:bg-gray-800 transition-colors px-6 py-4 rounded-lg cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <i className="ri-shield-check-line text-amber-400 text-xl"></i>
                <h3 className="text-lg font-bold">CUMPLIMIENTO EMPRESARIAL</h3>
              </div>
              <i className={`ri-arrow-down-s-line text-2xl transition-transform duration-300 ${isComplianceOpen ? 'rotate-180' : ''}`}></i>
            </button>
            
            <div
              className={`overflow-hidden transition-all duration-300 ${
                isComplianceOpen ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="bg-gray-900 rounded-lg px-6 py-4">
                <ul className="space-y-3">
                  <li>
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors group cursor-pointer"
                    >
                      <i className="ri-file-text-line text-gray-500 group-hover:text-amber-400 transition-colors"></i>
                      <span>Política de Privacidad y Cookies</span>
                      <i className="ri-external-link-line text-xs ml-auto"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors group cursor-pointer"
                    >
                      <i className="ri-file-text-line text-gray-500 group-hover:text-amber-400 transition-colors"></i>
                      <span>Reglamento Interno de Trabajo – Congarantías</span>
                      <i className="ri-external-link-line text-xs ml-auto"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors group cursor-pointer"
                    >
                      <i className="ri-file-text-line text-gray-500 group-hover:text-amber-400 transition-colors"></i>
                      <span>Norma de Protección de Datos Personales</span>
                      <i className="ri-external-link-line text-xs ml-auto"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Congarantías SAS. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
